import React from 'react';
import styled from "styled-components";
import { BookingPaymentType } from '../../Components/Types';
import { ConvertToPounds } from '../../Components/Functions';
import moment from 'moment';
import { useMediaQuery } from 'react-responsive';

type PaymentsTableProps = {
    bookingPayments: BookingPaymentType[];
}
const PaymentsTable = styled.table`
    margin: 2em 0em 2em 0em;
    width: 80%;
`;
const HeaderStyle = {
    fontFamily: "Poppins-SemiBold",
    fontSize: "1em"
}
const BodyCell = styled.td`
    color: var(--main-grey-color);
    font-size: 0.8em;
`;
const TableDivider = styled.div`
    height: 2px;
    width: 100%;
    background-color: var(--main-orange-color);
`;
function BookingPaymentsTable({ bookingPayments }: PaymentsTableProps) {
    
    const desktopView = useMediaQuery({
        query: '(min-width: 890px)'
    });


    return (
        <>
            {desktopView ?
                <PaymentsTable>
                    <tr>
                        <td style={HeaderStyle}>Item</td>
                        <td style={HeaderStyle}>Payment value</td>
                        <td style={HeaderStyle}>Transaction date</td>
                    </tr>
                    {bookingPayments.map((bookingPayment: BookingPaymentType) => {
                        const transactionDate = moment(new Date(Date.parse(bookingPayment.transaction_date)));
                        return (
                            <tr>
                                <BodyCell>{bookingPayment.item}</BodyCell>
                                <BodyCell>{ConvertToPounds(bookingPayment.payment_value)}</BodyCell>
                                <BodyCell>{transactionDate.format("DD/MM/YYYY")}</BodyCell>
                            </tr>
                        );
                    })}
                </PaymentsTable> :
                bookingPayments.map((bookingPayment: BookingPaymentType) => {
                    const transactionDate = moment(bookingPayment.transaction_date.split('T')[0]);
                    return (
                        <>
                            <p style={HeaderStyle}>{bookingPayment.item}</p>
                            <p>{ConvertToPounds(bookingPayment.payment_value)}</p>
                            <p>{transactionDate.format("DD/MM/YYYY")}</p>
                            <TableDivider />
                        </>
                    );
                })
            }
        </>
    );
}
export default BookingPaymentsTable;
